var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.assets),function(asset,i){return _c('div',{key:`asset-${i}`,staticClass:"mb-2 asset-item-width"},[_c('small',[_c('b-icon-file-earmark'),_vm._v(" "),_c('span',{},[_vm._v(_vm._s(decodeURI(asset.name)))])],1),_c('br')])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }